"use strict";

module.exports = function(angular, moduleName) {
  angular
    .module(moduleName)
    .constant("REDI_WEBAPP_CONFIG_PATH", "/openfin/redi-webapp-config.json")
    .constant("eikonErrorCodes", require("app/config/eikonErrorCodes.json"))
    .config(
      /* @ngInject */ function($logProvider) {
        $logProvider.debugEnabled(false);
      }
    )
    .config(require("app/config/routingConfig"))
    .run(require("app/config/routingSetup"));
};



// WEBPACK FOOTER //
// ./app/config/configIndex.js